module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0650.c8bac2e3.jpg";